// components
import CustomButton from "../CustomButton";
import StatisticInfo from "../StatisticInfo";
import Header from "../Header";

// utils
import dateFormat from "../../utils/dateFormat";

// constants
import {
  APP_UPDATE_DATE,
  APP_VERSION_FOR_SHOW,
} from "../../constants/appUpdates";

// styles
import classes from "./styles.module.css";

export default function UpdatesModal({ updateVersion }) {
  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <div className={classes.header}>
          <div className={classes.titleBox}>
            <div className={classes.smallInfo}>
              <p className={classes.version}>Версия {APP_VERSION_FOR_SHOW}</p>
              <p className={classes.date}>{dateFormat(APP_UPDATE_DATE)}</p>
            </div>
            <p className={classes.title}>Что нового в обновлении</p>
          </div>
          <div className={classes.closeButtonContainer}>
            <button onClick={updateVersion} className={classes.closeButton}>
              X
            </button>
          </div>
        </div>

        <div className={classes.updates}>
          <p style={{ marginBottom: 10 }}>
            Добавлен баланс магазина на верху экрана
          </p>

          <Header />

          <p>Добавлен новый пункт для статистики</p>
          <div style={{ width: "150px" }}>
            <StatisticInfo
              title="Чистые"
              value={`999 ֏`}
              valueStyles={{
                color: "#124d39",
                background: "#43ecb43a",
              }}
            />
          </div>

          <p>
            Исправлен счетчик который не правильно подсчитывал капитал в обороте
          </p>
        </div>

        <CustomButton
          onClick={updateVersion}
          className={classes.secondCloseButton}
        >
          Отлично, понятно
        </CustomButton>
      </div>
    </div>
  );
}
